export const PayScreenExperiment = Object.freeze({
  'Old': 'old',
  'New': 'new',
  'New2': 'new2',
})
